import React, { ReactNode, useContext } from "react";
import useRunicMemorise, { ModalStates } from "./Components/useRunicMemorise";

export type RunicContextType = {
  checkInputArray: Array<string>;
  currentIndexSelect: number;
  iluminate: boolean;
  runesArray: Array<string>;
  secuenceArray: Array<string>;
  setCheckInputArray: React.Dispatch<React.SetStateAction<string[]>>;
  setCurrentIndexSelect: React.Dispatch<React.SetStateAction<number>>;
  setIluminate: React.Dispatch<React.SetStateAction<boolean>>;
  setStart: React.Dispatch<React.SetStateAction<boolean>>;
  start: boolean;
  simonState: string;
  setSimonState: React.Dispatch<React.SetStateAction<string>>;
  testingInput: string;
  setTestingInput: React.Dispatch<React.SetStateAction<ModalStates>>;
  reset: () => void;
};

const useGame = () => {
  return useContext(GameContext);
};

export const GameContext = React.createContext<RunicContextType>({
  checkInputArray: [],
  currentIndexSelect: 0,
  iluminate: false,
  runesArray: [],
  secuenceArray: [],
  setCheckInputArray: () => null,
  setCurrentIndexSelect: () => null,
  setIluminate: () => null,
  setStart: () => null,
  start: false,
  simonState: "",
  setSimonState: () => "",
  testingInput: "",
  setTestingInput: () => "",
  reset: () => null
});

/**
 * @author Luis Sanchez
 */
export const GameContextProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const runicMemorise = useRunicMemorise();
  return (
    <GameContext.Provider value={{ ...runicMemorise }}>
      {children}
    </GameContext.Provider>
  );
};

export default useGame;
